@if (displayWarning) {
  <div class="warning">
    <div class="indicator">
      <i class="material-icons icon">warning</i>
    </div>
    <div class="message" innerHTML="{{ 'app.storageWarning.message' | translate: messageParams }}"></div>
  </div>
}
